export enum TranscriptionModels {
  CHIRP3 = 'chirp3',
  MEDICAL_DICTATION = 'medicalDictation',
  MEDICAL_CONVERSATION = 'medicalConversation',
}

export type TranscriptionModel = `${TranscriptionModels}`;

export interface BaseTranscriptionPayload {
  contentID?: string;
  chunkId?: string;
  language: string;
  settings: { model: TranscriptionModel };
  tenantId?: string;
  duration?: number;
}

export interface LiveTranscriptionPayload extends BaseTranscriptionPayload {
  data: ArrayBuffer | null;
}

export interface TranscriptionPayload extends BaseTranscriptionPayload {
  fileLink: string;
}

export enum SpeechEvent {
  // Client-to-server events
  /**
   * A chunk of audio data sent from the client to the server for transcription.
   * @param { data: Buffer, contentID: string, language: 'fr' | 'en' }
   */
  CLIENT_AUDIO_CHUNK = 'client:audio-chunk',

  /**
   * Sent from the client to signal that it has finished sending audio data
   * and the server should finalize the transcription.
   */
  CLIENT_STREAM_END = 'client:stream-end',

  // Server-to-client events
  /**
   * An in-progress, non-final transcription result sent from the server to the client.
   * @param { contentID: string, text: string, raw: any }
   */
  SERVER_TRANSCRIPTION_INTERIM = 'server:transcription-interim',

  /**
   * A final, corrected transcription result sent from the server to the client.
   * @param { contentID: string, text: string, raw: any }
   */
  SERVER_TRANSCRIPTION_FINAL = 'server:transcription-final',
}
